import createDOMPurify from 'dompurify'
import { createStripAnchorTags } from '~/utils/strip-anchor-tags'

export default defineNuxtPlugin({
  name: 'strip-anchor-tags',
  setup() {
    return {
      provide: {
        stripAnchorTags: createStripAnchorTags(createDOMPurify()),
      },
    }
  },
})
